import React, { useEffect } from "react";
import { PromoBar } from "./components/PromoBar";
import { Hero } from "./components/Hero";
import { PainSection } from "./components/PainSection";
import { HowItWorks } from "./components/HowItWorks";
import { BookContents } from "./components/BookContents";
import { Bonuses } from "./components/Bonuses";
import { Testimonials } from "./components/Testimonials";
import { Pricing } from "./components/Pricing";
import { Faq } from "./components/Faq";
import { Footer } from "./components/Footer";
import { MobileCtaBar } from "./components/MobileCtaBar";
import { initPixel } from "./utils/pixel";
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div lang="fr" className="min-h-screen w-full overflow-x-hidden bg-ink pb-20 font-sans text-cream antialiased md:pb-0" data-id="element-0" data-mp="2wjqhr811w6n6">
      <PromoBar data-id="element-1" data-mp="28t4k8aooa4rf" />
      <main data-id="element-2" data-mp="28sl5f2ubjwhm">
        <Hero data-id="element-3" data-mp="28s2y9b64bxux" />
        <PainSection data-id="element-4" data-mp="23vcm2yxfpmes" />
        <HowItWorks data-id="element-5" data-mp="23w4gi6fape3h" />
        <BookContents data-id="element-6" data-mp="23ujlygszdv5m" />
        <Bonuses data-id="element-7" data-mp="23t8heerpojdg" />
        <Testimonials data-id="element-8" data-mp="3ijxpcqos80jw" />
        <Pricing data-id="element-9" data-mp="3ikhaeg9qb525" />
        <Faq data-id="element-10" data-mp="3iiwfgpji5k3r" />
      </main>
      <Footer data-id="element-11" data-mp="3ijpc2xoqyt86" />
      <MobileCtaBar data-id="element-12" data-mp="3ii4t85bsoyq5" />
    </div>;
}